/**
 * Shared color tokens for the IQ visualization stack. Charts that need a
 * per-project color palette pull from `NEIGHBOR_PALETTE` so the legend
 * keys stay consistent across rows / charts. The "current" project is
 * always pinned to `YOU_COLOR` so it pops out across all surfaces.
 *
 * TODO: swap these for design-system tokens once the Blueprint theme
 * exposes per-series chart palettes.
 */

/** Color used to highlight the current project across all charts. */
export const YOU_COLOR = "#2fb0ff";

/** Grey used for "all other neighbors" collapse buckets. */
export const OTHER_NEIGHBOR_COLOR = "#cfd8e3";

/** Sticky color palette for neighbor projects in the Top Upgrades chart. */
export const NEIGHBOR_PALETTE: ReadonlyArray<string> = [
    "#7c5cff",
    "#19c39a",
    "#f7a23b",
    "#d6701f",
    "#e94f6a",
    "#0a6cb8",
    "#a463f2",
    "#3fc1c9",
    "#ffb84d",
    "#4dabf7"
];
